import React from "react";
import { Field, Form } from "react-final-form";
import InputField from "../../../components/InputField";
import TabsPatientSelection from "../../../components/TabsPatientSelection";
import Button from "../../../components/Button";
import { useLocalization } from "../../../../context/LocalizeContextProvider";
import { useDepositPatientValidation } from "../../../../utils/validation/useDepositPatientValidation";
import TitlePage from "../../../components/TitlePage";
import Card from "../../../components/Card";
import Spinner from "../../../components/Spinner";
import { Col, Row } from "react-bootstrap";
import SelectField from "../../../components/SelectField";
import { paymentMethod } from "../../../../utils/constants";

export default function FormDeposit({
  // Deposit props
  dataFormDeposit = {},
  handleChangeDepositForm = () => undefined,

  // Patient props
  selectedExistingPatient,
  setSelectedExistingPatient,
  dataFormNew,
  handleChangeForm,
  onTabChange,

  // Form props
  isEdit = false,
  activeTab,
  onSubmit = () => undefined,
  initialValues = {},
  loading = false,
}) {
  const localize = useLocalization();
  const validate = useDepositPatientValidation();

  // Form validation wrapper
  const validateForm = (values) => {
    return validate(values, activeTab, selectedExistingPatient);
  };
  const isCardNumber =
    dataFormDeposit.method === "CREDIT_CARD" ||
    dataFormDeposit.method === "DEBIT";

  return (
    <Card>
      <Spinner loading={loading}>
        <div className="wrapper">
          <TitlePage
            text={
              isEdit
                ? localize.getText("edit") + " " + localize.getText("deposit")
                : localize.getText("add") + " " + localize.getText("deposit")
            }
            isBack
          />
          <Form
            onSubmit={onSubmit}
            validate={validateForm}
            initialValues={initialValues}
          >
            {({ handleSubmit, valid, errors }) => (
              <form className="wrapper-form" onSubmit={handleSubmit}>
                {/* Deposit Form Section */}
                <div className="d-flex flex-column gap-3 mb-4">
                  <Field name="price">
                    {({ input, meta }) => (
                      <InputField
                        label={localize.getText("price")}
                        placeholder={localize.getText("placeholderField", {
                          fieldName: localize.getText("price"),
                        })}
                        error={meta.touched && meta.error}
                        onChange={(value) => {
                          input.onChange(value);
                          handleChangeDepositForm("price", value);
                        }}
                        onBlur={input.onBlur}
                        value={dataFormDeposit.price}
                        type="number"
                      />
                    )}
                  </Field>

                  <Row>
                    <Col md={isCardNumber ? 6 : 12}>
                      <Field name="method">
                        {({ input, meta }) => (
                          <SelectField
                            label="Metode"
                            placeholder="Pilih Metode Pembayaran"
                            data={paymentMethod}
                            labelKey="label"
                            valueKey="value"
                            onBlur={input.onBlur}
                            error={meta.touched && meta.error}
                            value={dataFormDeposit.method}
                            onChange={(value) =>
                              handleChangeDepositForm("method", value)
                            }
                          />
                        )}
                      </Field>
                    </Col>
                    {isCardNumber && (
                      <Col md={6}>
                        <Field name="cardNumber">
                          {({ input, meta }) => (
                            <InputField
                              label="Nomor Kartu"
                              placeholder="Masukkan Nomor Kartu"
                              onBlur={input.onBlur}
                              error={meta.touched && meta.error}
                              value={dataFormDeposit.cardNumber}
                              onChange={(value) =>
                                handleChangeDepositForm("cardNumber", value)
                              }
                            />
                          )}
                        </Field>
                      </Col>
                    )}
                  </Row>
                </div>

                {/* Patient Selection Section */}
                <Field name="existingPatient">
                  {({ meta, input }) => (
                    <div>
                      <TabsPatientSelection
                        label={localize.getText("selectPatient")}
                        selectedExistingPatient={selectedExistingPatient}
                        setSelectedExistingPatient={setSelectedExistingPatient}
                        dataFormNew={dataFormNew}
                        handleChangeForm={handleChangeForm}
                        onTabChange={onTabChange}
                        showFormForNewPatient={false}
                      />
                      {meta.touched && meta.error && (
                        <div className="text-danger mt-2">{meta.error}</div>
                      )}
                    </div>
                  )}
                </Field>

                <Button
                  label={localize.getText("save")}
                  style={{ width: 180, marginTop: 42 }}
                  type="submit"
                  loading={loading}
                />
              </form>
            )}
          </Form>
        </div>
      </Spinner>
    </Card>
  );
}
